import * as Types from 'src/actions/investment/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import IndexResponse from 'src/value-objects/IndexResponse';
import Investment from 'src/entities/Investment';

export interface GetInvestmentAttempt extends Action {
  type: Types.GET_INVESTMENT_ATTEMPT;
}

export interface GetInvestmentSuccess extends Action {
  type: Types.GET_INVESTMENT_SUCCESS;
  payload: Investment;
}

export interface GetInvestmentFailure extends Action {
  type: Types.GET_INVESTMENT_FAILURE;
}

export type GetInvestmentAction = GetInvestmentAttempt |
  GetInvestmentSuccess |
  GetInvestmentFailure;

export interface GetInvestmentThunk
  extends ThunkAction<Promise<GetInvestmentAction>, RootState, string> {
}

export const getInvestmentAttempt: ActionCreator<GetInvestmentAttempt> = () => (
  {
    type: Types.GET_INVESTMENT_ATTEMPT
  }
);

export const getInvestmentSuccess: ActionCreator<GetInvestmentSuccess> = (
  investments: Investment
) => ({
  type: Types.GET_INVESTMENT_SUCCESS,
  payload: investments
});

export const getInvestmentFailure: ActionCreator<GetInvestmentFailure> = () => ({
  type: Types.GET_INVESTMENT_FAILURE
});

export const getInvestment: ActionCreator<GetInvestmentThunk> = (
  projectId: number,
  profileId: number,
  profileType: string,
): GetInvestmentThunk => {
  return (dispatch: Dispatch<RootState>): Promise<GetInvestmentAction> => {
    dispatch(getInvestmentAttempt());
    return ApiClient.investment.index({
      personId: profileId,
      projectId: projectId,
      personType: profileType,
    }).then((response: AxiosResponse<IndexResponse<Investment>>): GetInvestmentSuccess => {
      if (response.data.content.length) {
        return dispatch(getInvestmentSuccess(response.data.content[0]));
      } else {
        throw Error('No investment found');
      }
    }).catch((): GetInvestmentFailure => {
      return dispatch(getInvestmentFailure());
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/investment/get/GetInvestment.actions.tsx